<template>
  <div class="process">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'审批流程'}]"></breadcrumb>
    <div class="process-wrap">
      <div class="process-contain">
        <public-top-nav>
          <el-button @click="addProcess()"
                     type="primary">
            <font-awesome-icon :icon="['fas', 'pencil-alt']" />
            <span style="margin-left:5px; font-size:14px;">新建审批流</span>
          </el-button>
        </public-top-nav>
        <div class="process-table-wrap">
          <div class="process-table">
            <table>
              <tr v-for="item in processList"
                  @click="editProcess(item.id)"
                  :key="item.id">
                <td>{{item.name}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="process-dialog"
               :title="this.processForm.id? '编辑流程':'新建流程'"
               :visible.sync="processFormShow">
      <el-form label-position="top"
               class="process-form">
        <el-row :gutter="15">
          <el-col :span="22">
            <el-form-item label="流程名称">
              <el-input clearable
                        placeholder="请输入"
                        v-model="processForm.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-for="(node,index) in processForm.nodeUserIdsList"
                :key="index"
                :gutter="15">
          <el-col :span="11">
            <el-form-item :label="'流程步骤'+(index+1)">
              <el-select v-model="node.userIdList"
                         multiple
                         placeholder="请选择">
                <el-option v-for="item in allUser"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="步骤名称">
              <el-input clearable
                        placeholder="请输入"
                        v-model="node.name"></el-input>
            </el-form-item>
          </el-col>
          <div v-if="index===processForm.nodeUserIdsList.length-1"
               class="process-icon">
            <span @click="delnode()">
              <font-awesome-icon style="color:#d0021b; margin-right:6px;  cursor:pointer"
                                 :icon="['fas', 'minus-circle']" />
            </span>
            <span @click="addnode()">
              <font-awesome-icon style="color:#39B54A; margin-right:10px; cursor:pointer"
                                 :icon="['fas', 'plus-circle']" />
            </span>
          </div>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submitProcessForm">提 交</el-button>
        <el-button @click="processFormShow= false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import publicTopNav from '@/components/publicTopNav'
export default {
  components: {
    breadcrumb,
    publicTopNav
  },
  data() {
    return {
      processList: [],

      allUser: [],

      processFormShow: false,
      processForm: {
        name: '',
        nodeUserIdsList: [
          {
            orderNum: 1,
            name: '',
            userIdList: []
          }
        ]
      }
    }
  },
  created() {
    this.getList()
    this.getAllUser()
  },
  methods: {
    getList() {
      axios
        .get(api.processAll)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取审批流列表成功', res.data.result)
            this.processList = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //添加审批
    addProcess() {
      this.processForm = {
        name: '',
        nodeUserIdsList: [
          {
            orderNum: 1,
            name: '',
            userIdList: []
          }
        ]
      }
      this.processFormShow = true
    },
    // 获取所有用户
    getAllUser() {
      axios
        .get(api.getAllUser)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取所有用户成功', res.data.result)
            this.allUser = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    //删除节点
    delnode() {
      if (this.processForm.nodeUserIdsList.length === 1) {
        this.$message.error('至少有一个审批节点')
        return
      }
      this.processForm.nodeUserIdsList.pop()
    },
    addnode() {
      this.processForm.nodeUserIdsList.push({
        name: '',
        userIdList: [],
        orderNum: this.processForm.nodeUserIdsList.length + 1
      })
    },
    submitProcessForm() {
      if (this.processForm.id) {
        axios
          .post(api.updateProcessNodesUsers, this.processForm)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '修改流程成功',
                type: 'success'
              })
              this.processFormShow = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
            this.$message.error('网络错误，稍后重试')
          })
      } else {
        axios
          .post(api.addProcessNodesUsers, this.processForm)
          .then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: '添加流程成功',
                type: 'success'
              })
              this.processFormShow = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(error => {
            this.$message.error('网络错误，稍后重试')
          })
      }
    },
    //获取审批流信息
    editProcess(id) {
      axios
        .get(api.getNodeList + '/' + id)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取审批流信息成功', res.data.result)
            this.processForm = res.data.result
            this.processFormShow = true
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，请稍后重试')
        })
    }
  }
}
</script>

<style lang="scss">
.process {
  .process-wrap {
    padding: 77px 30px 30px 30px;
    .process-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .process-table-wrap {
        padding: 30px;
        .process-table {
          min-height: 470px;
          tr {
            cursor: pointer;
            height: 47px;
            td {
              padding: 0px 19px;
              div {
                display: inline-block;
              }
            }
          }
        }
      }
    }
  }
  .process-dialog {
    .process-icon {
      position: absolute;
      right: -7px;
      bottom: 32px;
    }
    .el-dialog {
      min-width: 400px;
    }
    .el-dialog__header {
      color: #4a4a4a;
      font-weight: 600;
      font-size: 18px;
    }
    .el-dialog__body {
      padding-top: 6px;
      padding-bottom: 0px;
    }
    .el-dialog__footer {
      padding-top: 0px;
      text-align: left;
      .el-button {
        width: 88px;
      }
    }
  }
}
</style>
